import en from './en';

export const classTranslations: NamespaceTranslations<keyof typeof en> = {
  en,
};
